import React,{ useState} from 'react'
import CreateCardForm from './CreateCardForm'
const MainCreateCardForm = () => {
const [formStepStatus, setFormStepStatus] = useState({});

const handleStepStatusUpdate = (status) => {
  setFormStepStatus(status); // store in parent
};

const isCurrentStep = (stepNumber) => {
  const steps = [
    formStepStatus.Type,
    formStepStatus.Player,
    formStepStatus.Set,
    formStepStatus.Card,
    formStepStatus.Variation,
    formStepStatus.Image
  ];

  // The first `false` in the array is the current step
  const firstIncompleteIndex = steps.findIndex(step => !step);

  // If all steps are complete, default to none or last
  return stepNumber === (firstIncompleteIndex === -1 ? steps.length : firstIncompleteIndex + 1);
};
return (
  <section className='grid'>
    <div className="contentfront">
      
    
   {/* <div className="creation-progress-bar progress-top">
<div className={`step ${formStepStatus.Type ? "done" : ""} ${isCurrentStep(1) ? "current" : ""}`}>1. Type</div>
<div className={`step ${formStepStatus.Player ? "done" : ""} ${isCurrentStep(2) ? "current" : ""}`}>2. Joueur</div>
<div className={`step ${formStepStatus.Set ? "done" : ""} ${isCurrentStep(3) ? "current" : ""}`}>3. Set</div>
<div className={`step ${formStepStatus.Card ? "done" : ""} ${isCurrentStep(4) ? "current" : ""}`}>4. Carte</div>
<div className={`step ${formStepStatus.Variation ? "done" : ""} ${isCurrentStep(5) ? "current" : ""}`}>5. Variation</div>
<div className={`step ${formStepStatus.Image ? "done" : ""} ${isCurrentStep(6) ? "current" : ""}`}>6. Image</div>

        
      </div> */}
      <CreateCardForm onStepUpdate={handleStepStatusUpdate} />
    
       <div className="creation-progress-bar progress-bottom">
   <div className={`step ${formStepStatus.Type ? "done" : ""} ${isCurrentStep(1) ? "current" : ""}`}>1. Type</div>
<div className={`step ${formStepStatus.Player ? "done" : ""} ${isCurrentStep(2) ? "current" : ""}`}>2. Joueur</div>
<div className={`step ${formStepStatus.Set ? "done" : ""} ${isCurrentStep(3) ? "current" : ""}`}>3. Set</div>
<div className={`step ${formStepStatus.Card ? "done" : ""} ${isCurrentStep(4) ? "current" : ""}`}>4. Carte</div>
<div className={`step ${formStepStatus.Variation ? "done" : ""} ${isCurrentStep(5) ? "current" : ""}`}>5. Variation</div>
<div className={`step ${formStepStatus.Image ? "done" : ""} ${isCurrentStep(6) ? "current" : ""}`}>6. Image</div>

        
      </div>
    </div>
  </section>
);

}

export default MainCreateCardForm